import ZkModifyPwd from './src/main'
ZkModifyPwd.install = function (Vue) {
  Vue.component(ZkModifyPwd.name, ZkModifyPwd)
}
export default ZkModifyPwd



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/modifyPwd/index.js